import { Entry, IEntry, ISys } from '../base'

export interface ITagFields {
  title: string
  slug: string
  sortOrder?: number
}

/**
 * Tag
 */
export interface ITag extends IEntry<ITagFields> {}

export function isTag(entry: IEntry<any>): entry is ITag {
  return (
    entry &&
    entry.sys &&
    entry.sys.contentType &&
    entry.sys.contentType.sys &&
    entry.sys.contentType.sys.id == 'tag'
  )
}

export class Tag extends Entry<ITagFields> implements ITag {
  public readonly sys!: ISys<'Entry'>
  public readonly fields!: ITagFields

  get title(): string {
    return this.fields.title
  }

  get slug(): string {
    return this.fields.slug
  }

  get sortOrder(): number | undefined {
    return this.fields.sortOrder
  }

  get sort_order(): number | undefined {
    return this.fields.sortOrder
  }

  constructor(entry: ITag)
  constructor(id: string, fields: ITagFields)
  constructor(entryOrId: ITag | string, fields?: ITagFields) {
    super(entryOrId, 'tag', fields)
  }
}
